<template>
  <div class="custom-select-box" :tabindex="tabindex" @focusout="handleFocusOut" ref="select-box">
    <div class="selected" :class="{ open: open, error: error }" @click="open = !open">
      <span v-if="selectedOptions.length">{{ Number(selectedOptions.length) }} answers selected</span>
      <span v-else>Select answer(s)</span>
    </div>
    <div ref="options" class="items" :class="{ selectHide: !open }">
      <div class="item" v-for="option of options" :key="`multiple-choice-option-${option.id}`">
        <label>
          <input
            :id="option.id"
            :value="{
              id: option.id,
              body: option.body,
              sequence: option.sequence
            }"
            type="checkbox"
            v-model="selectedOptions"
            @change="$emit('input', selectedOptions)"
          />
          <span class></span>
          {{ option.body }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleChoiceOtionsDropDown",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOptionId: {
      type: Array
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedOptionId: {
      handler(selectedOptionIds) {
        if (!selectedOptionIds) {
          this.selectedOptions = [];
          return;
        }

        this.selectedOptions = selectedOptionIds;
      },
      deep: true
    },
    options: {
      handler() {},
      deep: true
    }
  },
  data() {
    return {
      selectedOptions: this.selectedOptionId,
      open: false
    };
  },
  methods: {
    handleFocusOut(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.open = false;
      }
    }
  },
  mounted() {
    this.$emit("input", this.selectedOptions);
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;

  .selected {
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #d3dfe4;
    color: #4a4a4a;
    padding: 7px;
    padding-left: 11px;
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;

    &:after {
      position: absolute;
      content: "";
      top: 13px;
      right: 10px;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-color: #b0bac9 transparent transparent transparent;
    }

    &.error {
      border-color: #f16559;
    }
  }

  .items {
    color: #4a4a4a;
    border-radius: 4px;
    overflow: hidden;
    position: absolute;
    background-color: #ffffff;
    left: 11px;
    right: 1px;
    top: 9px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
    z-index: 1;
    min-width: 316px;
    max-height: 223px;
    overflow-y: auto;
    padding: 16px;
    font-size: 14px;

    scrollbar-width: thin;
    /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent;

    /* scroll thumb & track */
    &::-webkit-scrollbar {
      width: 7px;
      /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      /* color of the tracking area */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c5d1d6;
      /* color of the scroll thumb */
      border-radius: 20px;
      /* roundness of the scroll thumb */
      border: 3px solid transparent;
      /* creates padding around scroll thumb */
    }

    .item {
      cursor: pointer;
      user-select: none;
      margin-bottom: 4px;

      &:hover {
        background-color: #f8f9fa;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      /*checkbox data*/

      label {
        width: 100%;
        cursor: pointer;

        span {
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      input[type="checkbox"] {
        display: none;
        height: 16px;
        width: 16px;
      }

      input[type="checkbox"] + span:before {
        content: "";
        border: 0.1em solid #959fa4;
        border-radius: 4px;
        width: 16px;
        height: 16px;
        padding: 4px;
        color: transparent;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center center;
        display: inline-block;
        margin-top: 2px;
      }

      input[type="checkbox"]:checked + span:before {
        background-color: #4c8ce4;
        border: 0.1em solid #4c8ce4;
        color: #fff;
        background-image: url(/static/img/checked-checkbox.svg);
      }
    }
  }
}

.selectHide {
  display: none;
}
</style>
